const authReducer = (state = '', action) => {
    switch (action.type) {
        case 'LOGIN_ERROR':
            return action.err;
        default:
            return state
    }
};

export default authReducer